export default __webpack_public_path__ + "static/media/whatToDo_1.88b79b0f.png";